module.exports = __webpack_public_path__ + "static/media/6.7f1976ef.png";